import propsTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import config from "../../utils/config";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    fontSize: 17,
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "block",
    },
  },
  titleLeft: {
    fontSize: 15,
    flex: 1,
  },
}));

const Stack = (props) => {
  const classes = useStyles();

  const {
    title,
    theme,
    headerRight,
    headerLeft,
    handleChangeStatus,
    className,
  } = props;

  return (
    <AppBar className={`${classes.appBar} ${className}`}>
      <Toolbar className={`headerContainer ${theme.isDarkTheme && "dark"}`}>
        {headerRight ? (
          headerRight()
        ) : (
          <>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleChangeStatus}
              aria-label="close"
            >
              <ArrowForwardIcon />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
              {title}
            </Typography>
          </>
        )}
        <Typography className={classes.titleLeft} variant="h6" noWrap>
          {headerLeft ? headerLeft() : false}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

Stack.propsTypes = {
  title: propsTypes.string,
  headerRight: propsTypes.elementType,
  headerLeft: propsTypes.elementType,
};

Stack.defaultProps = {
  title: config.title,
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Stack);
